import { useMemo } from 'react';
import { Info } from 'react-feather';
import styled from '@emotion/styled';
import { BaseMessageButton } from '@trinity/chat-components/components/Chat/Message.Button';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip';

export type MarkdownInfoChipProps = {
  className?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  text: React.ReactNode;
  children?: React.ReactNode;
  inline?: boolean;
};

type Props = MarkdownInfoChipProps;

export const MarkdownInfoChip = (props: Props) => {

  const placement = useMemo(() => {
    return props.placement ? props.placement : `right`;
  }, [props.placement]);

  const tooltipText = useMemo(() => {
    if (!props.text) return '';
    if (typeof props.text !== 'string') return props.text;
    // Handle both actual newlines and literal \n strings
    const splitLines = props.text.split(/(?:<br\/?>|\\n|\n)+/);
    return splitLines.map((line, idx) =>
      idx === 0 ? line : [<br key={idx} />, line],
    );
  }, [props.text]);

  return (
    <Tooltip title={tooltipText} placement={placement}>
      <StyledBaseMessageButton className={props.className} inline={props.inline}>
        <StyledInfoIcon /> <StyledChildren>{props.children}</StyledChildren>
      </StyledBaseMessageButton>
    </Tooltip>
  );
};

const StyledBaseMessageButton = styled(BaseMessageButton, {
  shouldForwardProp: prop => prop !== 'inline',
})<{ inline?: boolean }>(({ inline }) => ({
  display: inline ? 'inline-flex' : 'flex',
  alignItems: 'center',
  minWidth: '0',
}));

export const StyledInfoIcon = styled(Info)(({ theme }) => ({
  stroke: theme.palette.badge.citation.color,
  height: 18,
  width: 18,
}));

export const StyledChildren = styled.div(() => ({
  marginLeft: '5px',
}));